<template>
    <div class="common-page">
        <div class="full-banner">
            <div class="wrapper">
                <h1>Aplicações</h1>
            </div>
        </div>
        <div class="applications wrapper" v-if="!loading">
                <div v-for="(lvl0, i0) in industries[0].industry"  :key="i0">
                    <div class="text">
                        <h2>{{ lvl0.title }}</h2>
                        <p @click="application = lvl0">Clique para ver mais <i class="mdi mid-arrow-right"></i></p>
                    </div>
                    <div class="figures">
                        <figure :style="`background-image: url(${lvl0.photos[!lvl0.id ? 0 : lvl0.id].url})`"></figure>
                    </div>
                    <div  class="dots">
                        <span v-for="(fig0, f0) in lvl0.photos" :key="f0">
                            <button @click="lvl0.id = f0" :class="{'dot-active': lvl0.id == f0}"></button>
                        </span>
                    </div>
                </div>
            <div class="description-application" :class="{'open': application}">
                <div v-if="application">
                    <div class="--bg">
                        <div class="img" :style="styleIndustry"></div>
                        <div class="wrapper">
                            <h1 class="title">{{ application.title }}</h1>
                        </div>
                    </div>
                    <i class="mdi mdi-cancel" style="position: fixed; top: 90px; right: 15px; font-size: 1.5em; color: #fff" @click="application = null"></i>
                    <div class="figures">
                        <figure v-for="(photo, f) in application.photos" :key="f">
                            <img :src="photo.url" :key="f">
                        </figure>
                    </div>
                    <div class="wrapper">
                        <h1>Soluções</h1>
                        <h2>Escolha um modelo para saber mais informações.</h2> 
                        <div v-for="(cat, i) in industryMachines" :key="i">
                            <h4>{{ i }}</h4>
                            <ol class="ais-Hits-list">
                                <li v-for="(item, m) in cat" :key="m" class="ais-Hits-item">
                                    <router-link :to="{path: '/maquina/'+item.uri}" class="card">
                                        <img v-if="item.files.images.length > 0" :src="item.files.images[0].url">
                                        <img v-else src="https://via.placeholder.com/800x600/ffffff/808080?text=Sem imagem">
                                        <div class="card-description">
                                            <h2>{{ item.shortName }}</h2>
                                            <h4>{{ item.category.name }}</h4>
                                        </div>
                                    </router-link>
                                </li>
                            </ol>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <get-in-touch id="get"></get-in-touch>
    </div>
</template>
<script>

import GetInTouch from '../components/GetInTouch.vue'
export default {
    name: "Application",
    components: {
        GetInTouch,
    },
    data(){
        return {
            scrolled: 0,
            machines: [],
            options: {
                type        : 'slide',
                rewind      : false,
                width       : '100%',
                gap         : 0,
                pagination  : false,
                fixedWidth  : 400,
                fixedHeight : '100%',
                cover       : true,
                focus       : 'center',
                isNavigation: false,
                lazyLoad: 'sequential',
                arrows: false
            },
            splide: null,
            industries: [],
            loading: true,
            application: null,

        }
    },
    watch: {
        'application'(nV){
            if(nV && nV.title){
                this.$router.push(`/aplicacoes/${nV.title}`)
            }
            else{
                this.$router.push('/aplicacoes')
            }
        }
    },
    mounted(){
        this.loadServices()
        this.loadList()
        // this.onScroll()
        // window.addEventListener('scroll', this.onScroll, false)
    },
    computed: {
        styleIndustry(){
            let css = ''
            if(this.application && this.application.title){
                css =  {'background': 'url(' + this.application.photos[0].url +')'}
            }
            return css
        },
        industryMachines(){
            let machines = {}
            if(this.application && this.application.title  && this.machines.length){
                // if(!this.application.title.includes(' > ')){
                    this.machines.forEach((machine) => {
                        
                        // if(machine.hasOwnProperty('industry.lvl0'))
                        // machine['industry.lvl0'].forEach((type) => {
                        //     if(this.application.title == type){
                            console.log(machine)
                            if(machine.hasOwnProperty('industry.lvl0')){
                                for(let i=0; i< machine["industry.lvl0"].length; i++){
                                    if(this.application.title == machine["industry.lvl0"][i]){
                                        if(machine.category && machine.category.name){
                                            if(!machines.hasOwnProperty(machine.category.name)){
                                                machines[machine.category.name] = []
                                            }
                                            machines[machine.category.name].push(machine)
                                        }
                                        
                                    }
                                }
                            }
                            // }
                        // })
                    })
                // }
            }
            return machines
        }
    },
    methods:{
        loadList(){
            this.machines = []
            this.$db.collection("machines").get()
            .then((snap) => {
                let machines = []
                snap.forEach((doc) => {
                    let data = doc.data()
                    data.docId = doc.id
                    machines.push(data)
                });

                this.machines = machines
            })
        },
        
        onScroll(){
            console.log(this.splide.computed)
            if(this.scrolled < window.scrollY){
                if(this.splide.computed.index < (this.splide.computed.length - 1)){
                    this.splide.go('+')
                }
            }
            //     this.$refs.primary.go('-')
            // }
            // else{
            //     this.$refs.primary.go('+')
            // }
            this.scrolled = window.scrollY
        },
        loadServices(){
            this.loading = true
            this.$db.collection("aplications").get().then((snap) => {
                let industry = []
                this.loading = true
                snap.forEach((doc) => {
                    let data = doc.data()
                    data.docId = doc.id
                    industry.push(data)
                    
                    // if(this.$route.params.cat)
                    // data.industry.forEach((item, itemIndex) => {
                    //     data.industry[itemIndex].id = 0
                // if(this.$route.params.cat == item.title){
                                // this.application = item
                            // }
                        // })
                
                });

                this.industries = industry
                
                this.loading = false
            })
            setTimeout(() => {
                this.splide = this.$refs.primary
            },100)
        }
    }
}
</script>
<style scoped lang="scss">
.--bg{
    height: 130px;
    width: 100vw;
    // z-index: 1;
    background: #32499b;
    .img{
        position: absolute;
        filter: grayscale(1) brightness(0.75);
        width: 100vw;
        height: 130px;
        top: 75px;
        left: 0;
        content: "";
        // z-index: 0;
        opacity: .6;
    }
}
.description-application{
    .wrapper{
        position: relative;
        .title{
        color: #fff;
        line-height: 130px;
        margin: 0;
        padding: 0;
        }
    }
    .figures{
        width: 100vw;
        display: flex;
        flex-wrap: wrap;
        padding-bottom: 15px;
        figure{
            flex: 0 0 33.33%;
            height: 240px;
            overflow: hidden;
            padding: 0;
            margin: 0;
        }
        img{
            width: 100%;
            min-height: 240px;
        }
    }
    position: fixed;
    padding-top: 75px;
    top: 0;
    left: 0;
    width: 100vw;
    height: calc(100vh);
    background: #f3f2f0;
    box-sizing: border-box;
    z-index: 4;
    opacity: 0.1;
    transition: .3s all ease-in-out;
    border-left: 1px solid rgba(160, 160, 160, 0.3);
    overflow-x: hidden;
    overflow-y: scroll;
    pointer-events: none;
    &.open{
        left: 0;
        pointer-events: all;
        opacity: 1;
        -webkit-clip-path: polygon(100% 0,0 0,0 100%,100% 100%);
        clip-path: polygon(100% 0,0 0,0 100%,100% 100%);
        -webkit-animation: clip-enter .5s ease forwards;
    }
}
    
    .flex{
        flex-wrap: nowrap;
    }
    .main-application{
        overflow-x: auto;
        overflow-y: hidden;
        height: calc(100vh - 75px);
    }
    .splide__slide{

    }
    .cat{
        // display: flex;
        // flex: 0 0 60%;
        max-width: 400px;
    }
        // display: flex;
        // flex-flow: column;
        // align-items: center;
        // justify-content: flex-start;
        
        .lvl-1, .splide__slide{
            border-left: 1px solid rgba(160, 160, 160, 0.3);
            padding: 0;
            display: flex;
            flex-flow: column;
            transition: .5s all;
            max-width: 400px;
            height: calc(100vh - 75px) !important;
            cursor:grab;
            > .text{
                display: flex;
                flex-wrap: wrap;
                align-items: flex-end;
                align-content: flex-end;
                padding: 10px;
                > h2{
                    padding: 0;
                    margin: 10px 0 0 0;
                    font-size: 2.2em;
                    color: #32499b;
                }
                > p{
                    padding: 0;
                    margin: 10px 0;
                    opacity: 0;
                    transition: .3s all;
                    cursor: pointer;
                    transform: translateX(20px);
                }
                > *{
                    flex: 0 0 100%;
                }
            }
            
            > * {
                flex: 0 0 50%;
            }
           
            img{
                opacity: .6;
                filter: grayscale(1) brightness(0.75);
                width: 100%;
                transition: 0.5s;
            }
            > .figures{
                border-top: 1px solid rgba(160, 160, 160, 0.3); 
                position: relative;
                width: 100%;
                height: 100%;
                overflow: hidden;
                > figure{
                    display: none;
                    background: #32499b; //#f3f2f0;
                    margin: 0;
                    padding: 0;
                    height: 100%;
                    width: 100%;
                    // max-width: 200px;
                    overflow: hidden;
                    justify-content: center;
                    
                    &:first-child{
                        display: flex;
                    }
                }

            }
            &:hover{
                background: #f3f2f0;
                .text p{
                    opacity: 1;
                    transform: translateX(0);
                }
                img{

                    opacity: 1;
                    filter: grayscale(0) brightness(0.75);
                }

            }
        }
        
    
    
    .cat.lvl-2{
        display: none;
    }


    @-webkit-keyframes clip-enter{
        0%{
            -webkit-clip-path:polygon(100% 0,100% 0,100% 100%,100% 100%);
            clip-path:polygon(100% 0,100% 0,100% 100%,100% 100%)
        }
        to{
            -webkit-clip-path:polygon(100% 0,0 0,0 100%,100% 100%);
            clip-path:polygon(100% 0,0 0,0 100%,100% 100%)
        }
    }
    @keyframes clip-enter{
        0%{
            -webkit-clip-path:polygon(100% 0,100% 0,100% 100%,100% 100%);
            clip-path:polygon(100% 0,100% 0,100% 100%,100% 100%)
        }
        to{
            -webkit-clip-path:polygon(100% 0,0 0,0 100%,100% 100%);
            clip-path:polygon(100% 0,0 0,0 100%,100% 100%)
        }
    }
    .ais-Hits-list{
        padding: 0;
        margin: 0;
    }
    .ais-Hits-item{
        margin-left: 0; 
        margin-right: 10px;
        
    }
</style>